import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { preloadTranslations } from "./hooks/useTranslation";
import { registerPwaInstallListeners, registerServiceWorker } from "./lib/pwaInstall";

// Preload common language translations for instant switching
preloadTranslations(['en', 'es', 'fr', 'pt', 'de', 'it', 'zh', 'ja', 'ko', 'ar', 'hi']);

registerPwaInstallListeners();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);
